import React from 'react'

function TRY({ className, size }) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size ?? 32}
      height={size ?? 32}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z'
        fill='#00B26B'
      />
      <path
        d='M14.7507 5H11.6969V9.38163L9 10.4795V13.0907L11.6969 11.9928V13.971L9 15.059V17.6701L11.6969 16.5723V25.3652C12.4008 25.474 13.5609 25.5333 14.7011 25.5333C19.6686 25.5333 22.9901 22.4078 23 16.1964H19.9164C19.9164 21.0528 17.7153 22.8232 14.7507 22.843V15.3359L18.6374 13.7633V11.162L14.7507 12.7346V10.7565L18.6374 9.18381V6.56275L14.7507 8.14528V5Z'
        fill='white'
      />
    </svg>
  )
}

export default TRY
